import React, { useState } from 'react';
import { format, parseISO } from 'date-fns';
import { CalendarDays } from 'lucide-react';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

// Shadcn date picker that reads/writes 'YYYY-MM-DD'.
export function DatePickerField({ value, onChange, testId = 'date-picker' }) {
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className="w-full flex items-center justify-between text-sm border border-[#E2E2DF] rounded-lg px-3 py-2 bg-white hover:border-slate-400 transition-colors">
          <span className={date ? 'text-slate-800' : 'text-slate-400'}>{date ? format(date, 'EEE d MMM yyyy') : 'Pick a date'}</span>
          <CalendarDays size={14} className="text-slate-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 z-[70]" align="start" data-testid={`${testId}-popover`}>
        <Calendar mode="single" selected={date} defaultMonth={date}
          onSelect={(d) => { if (d) { onChange(format(d, 'yyyy-MM-dd')); setOpen(false); } }} initialFocus />
      </PopoverContent>
    </Popover>
  );
}
